
import { Payload } from "@/types/profile";

export const educationPayloads: Payload[] = [
  // ClassKit payloads
  {
    id: "classkit",
    name: "ClassKit",
    description: "Configure ClassKit settings",
    category: "Education",
    supportedPlatforms: ["ios", "ipados"],
    configFields: [
      {
        id: "allowClasskit",
        name: "Allow ClassKit",
        type: "boolean",
        required: true,
        default: true,
        description: "Allow apps to add to ClassKit"
      }
    ]
  }
];
